import { render } from "./MemberIcon.vue?vue&type=template&id=9914b7f8&scoped=true"
import script from "./MemberIcon.vue?vue&type=script&lang=js"
export * from "./MemberIcon.vue?vue&type=script&lang=js"

import "./MemberIcon.vue?vue&type=style&index=0&id=9914b7f8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9914b7f8"]])

export default __exports__